import type { TrumpSuit } from '@/types';
import { cn } from '@/lib/utils';

const SUITS: { suit: TrumpSuit; symbol: string; color: string }[] = [
  { suit: 'hearts', symbol: '\u2665', color: 'text-red-500' },
  { suit: 'diamonds', symbol: '\u2666', color: 'text-red-500' },
  { suit: 'clubs', symbol: '\u2663', color: 'text-foreground' },
  { suit: 'spades', symbol: '\u2660', color: 'text-foreground' },
];

interface InlineTrumpSelectorProps {
  participantId: string;
  selectedSuit: TrumpSuit | null;
  isSelected: boolean;
  onSelect: (participantId: string, suit: TrumpSuit) => void;
}

export function InlineTrumpSelector({
  participantId,
  selectedSuit,
  isSelected,
  onSelect,
}: InlineTrumpSelectorProps) {
  return (
    <div className="flex gap-1">
      {SUITS.map(({ suit, symbol, color }) => {
        const isThisSuitSelected = isSelected && selectedSuit === suit;
        return (
          <button
            key={suit}
            type="button"
            onClick={() => onSelect(participantId, suit)}
            className={cn(
              'h-8 w-8 rounded text-lg font-bold transition-all',
              isThisSuitSelected
                ? 'bg-primary text-primary-foreground scale-110'
                : cn('hover:bg-muted', color, 'opacity-60 hover:opacity-100')
            )}
          >
            {symbol}
          </button>
        );
      })}
    </div>
  );
}

export function getSuitSymbol(suit: TrumpSuit): string {
  const suitData = SUITS.find((s) => s.suit === suit);
  return suitData?.symbol ?? '';
}

export function getSuitColor(suit: TrumpSuit): string {
  const suitData = SUITS.find((s) => s.suit === suit);
  return suitData?.color ?? '';
}
